<template>
  <div class="flex gap-1.5 flex-wrap">
    <button
      v-for="option in options"
      :key="String(option.value)"
      type="button"
      class="px-3.5 py-1.5 rounded-full text-xs whitespace-nowrap border transition-colors"
      :class="modelValue === option.value
        ? 'bg-primary text-white font-semibold border-transparent'
        : 'bg-white text-surface-600 border-surface-200'"
      :disabled="disabled"
      @click="$emit('update:modelValue', option.value)"
    >{{ option.label }}</button>
  </div>
</template>

<script setup lang="ts" generic="T extends string | number">
defineProps<{
  options: Array<{ value: T; label: string }>;
  modelValue?: T;
  disabled?: boolean;
}>();
defineEmits<{ 'update:modelValue': [value: T] }>();
</script>
